// Utils and error handlers
import moment from 'moment';
import { apiV1AxiosInstanceLogin, apiV1AxiosInstance, msZipCodeAxiosInstance, apiV1AxiosInstanceForm, apiV1AxiosProvisionalInstance } from './http';
import { toUpperIfString } from '../utils/textFormat';
// Base URL:https://api.autopaquete.com.mx/v1

const login = (data) =>
  apiV1AxiosInstanceLogin('/user-login', {
    method: 'POST',
    data: {
      user_email: data.email,
      password: data.password,
    },
  })
    .then((response) => {
      // console.log(response);
      return response.data;
    })
    .catch((error) => {
      // console.log('login error', error.response);
      return error.response.data;
    });
const register = (data) =>
  apiV1AxiosInstanceLogin('/signup', {
    method: 'POST',
    data: {
      full_name: data.name,
      read_terms: data.terms,
      reference_code: data.referCode || 'V004',
      phone: data.phone,
      email: data.email,
      password: data.password,
    },
  })
    .then((response) => {
      // console.log('register response', response.data);
      return response.data;
    })
    .catch((error) => {
      // console.log('register catch error', error.response);

      return error.response.data;
    });
// ****************  GETS  ******************************
const getVerificationStatus = () =>
  apiV1AxiosProvisionalInstance('/onboarding-status/', { method: 'GET' })
    .then((response) => {
      // console.log('-------- getVerificationStatus response ---------->', response.data);
      return response.data;
    })
    .catch((error) => {
      //  console.log('-------- getVerificationStatus catch err ---------->', error.response.data);
      return Promise.reject(error);
    });
const getVerificationUpdate = (status) =>
  apiV1AxiosProvisionalInstance(`/identity-verification/update/?status=${status}`, { method: 'GET' })
    .then((response) => {
      // console.log('-------- getVerificationUpdate response ---------->', response.data);
      return response.data;
    })
    .catch((error) => {
      //  console.log('-------- getVerificationUpdate catch err ---------->', error.response.data);
      return Promise.reject(error);
    });
const getProfile = () =>
  apiV1AxiosInstance('/profile/detail/', { method: 'GET' })
    .then((response) => {
      // console.log('-------- getProfile response ---------->', response.data);
      return response.data;
    })
    .catch((error) => {
      //  console.log('-------- getProfile catch err ---------->', error.response.data);
      return Promise.reject(error);
    });
const getBillingInfo = () =>
  apiV1AxiosInstance('/billing/detail/', { method: 'GET' })
    .then((response) => {
      // console.log('-------- getBillingInfo response ---------->', response.data);
      return response.data;
    })
    .catch((error) => {
      //  console.log('-------- getBillingInfo catch err ---------->', error.response.data);
      return Promise.reject(error);
    });
const validateEmail = (code) =>
  apiV1AxiosInstance(`/confirm-email-code/${code}`, { method: 'GET' })
    .then((response) => {
      // ('-------- validateEmail response ---------->', response.data);
      return response.data;
    })
    .catch((error) => {
      // console.log('-------- validateEmail catch err ---------->', error.response.data);
      return error.response.data;
    });
const sendVerificationCode = (email) =>
  apiV1AxiosInstance(`/send-verification-code-again/?email=${email}`, { method: 'GET' })
    .then((response) => {
      // console.log('-------- sendVerificationCode response ---------->', response.data);
      return response.data;
    })
    .catch((error) => {
      // console.log('-------- sendVerificationCode catch err ---------->', error.response.data);
      return error.response.data;
    });

const getCounters = () =>
  apiV1AxiosInstance('/home-counters/', { method: 'GET' }).then((response) => {
    // console.log('-------- getCounter response ---------->', response.data);
    return response.data;
  });

const getZipCode = (cp) =>
  msZipCodeAxiosInstance(`/${cp}/`, {
    method: 'GET',
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response;
    });
// get rate shippings y cotizador
// const getRates2 = (data) =>
//   apiV1AxiosInstance(`/rates`, {
//     method: 'POST',
//     timeout: 20000,
//     data: {
//       zip_from: data.zipFrom,
//       zip_to: data.zipTo,
//       parcel: {
//         height: data.height,
//         width: data.width,
//         depth: data.depth,
//         weight: data.weight,
//         product_value: data.productValue ? data.productValue : 0,
//         multi_pieces: data.multi_pieces,
//       },
//     },
//   }).then((response) => {
//     return response.data;
//   });
// simulator rates
const getRates = (data, simulateErrorCode = null) => {
  if (simulateErrorCode === 400 || simulateErrorCode === 500) {
    const error = new Error(`Simulación de error ${simulateErrorCode}`);
    error.response = {
      status: simulateErrorCode,
      data: {
        error: { example: [`Mensaje de error simulado. status ${simulateErrorCode}`] },
      },
    };
    return Promise.reject(error);
  }

  return apiV1AxiosInstance(`/rates`, {
    method: 'POST',
    timeout: 20000,
    data: {
      zip_from: data.zipFrom,
      zip_to: data.zipTo,
      parcel: {
        height: data.height,
        width: data.width,
        depth: data.depth,
        weight: data.weight,
        product_value: data.productValue ? data.productValue : 0,
        multi_pieces: data.multi_pieces,
      },
    },
  }).then((response) => response.data);
};
// Shippings
const getShippingHistory = async (num, limit) =>
  apiV1AxiosInstance(`/shippings/list/?page=${num}&page_size=${limit}`, {
    method: 'GET',
    timeout: 35000,
  })
    .then((response) => {
      // console.log('-------- getShippingHistory response ---------->', response.data);
      return response.data;
    })
    .catch((error) => {
      // console.log('-------- getShippingHistory catch err ---------->', error);
      return error.response.data;
    });
const getShippingDetails = (idLabel) =>
  apiV1AxiosInstance(`/shippings/detail/${idLabel}`, {
    method: 'GET',
  })
    .then((response) => {
      // console.log('-------- getShippingDetails response ---------->', response);
      return response.data;
    })
    .catch((error) => {
      // console.log('-------- getShippingDetails catch err ---------->', error.response);
      return error.response.data;
    });
const getFilteredHistory = async (currentPage, pageSize, identifier, carrier, startDate, endDate, tracking) => {
  const startDateFormat = startDate ? moment(startDate).format('YYYY-MM-DD') : startDate;
  const endDateFormat = startDate ? moment(endDate).format('YYYY-MM-DD') : endDate;
  try {
    const response = await apiV1AxiosInstance(
      `/shippings/list/?term=${identifier}&shipping_company=${carrier}&date=${startDateFormat}&end_date=${endDateFormat}&page=${currentPage}&page_size=${pageSize}&tracking_status=${tracking}`,
      {
        method: 'GET',
      }
    );
    return response.data;
  } catch (error) {
    // console.log('-------- getFilteredHistory catch err ---------->', error.response);
    return error.response.data;
  }
};
// Statements
const getStatementsHistory = (num, limit) =>
  // name_concept end_date  date
  apiV1AxiosInstance(`/statements/list/?page=${num}&page_size=${limit}`, {
    method: 'GET',
  }).then((response) => {
    // console.log('-------- getMovementsHistory response ---------->', response);

    return response.data;
  });
// .catch((error) => {
//   // console.log('-------- getMovementsHistory catch err ---------->', error.response.data);
//   return error.response.data;
// });
const getStatementsFiltered = (num, limit, concept, startDate, endDate) =>
  // name_concept end_date  date
  apiV1AxiosInstance(`/statements/list/?page=${num}&page_size=${limit}&date=${startDate}&end_date=${endDate}&name_concept=${concept}`, {
    method: 'GET',
  }).then((response) => {
    // console.log('-------- getStatementsFiltered response ---------->', response);

    return response.data;
  });
// .catch((error) => {
//   // console.log('-------- getStatementsFiltered catch err ---------->', error.response.data);
//   return error.response.data;
// });
// Overweight
const getOverweightHistory = (num, limit) =>
  apiV1AxiosInstance(`/overweights/list/?page=${num}&page_size=${limit}`, {
    method: 'GET',
    timeout: 35000,
  })
    .then((response) => {
      // console.log('-------- getOverweightHistory res ---------->', response);
      return response.data;
    })
    .catch((error) => {
      // console.log('-------- getOverweightHistory catch err ---------->', error.response.data);
      return error.response.data;
    });
// Pickups
const getPickups = (num, limit) =>
  apiV1AxiosInstance(`pickups/list/?page=${num}&page_size=${limit}`, {
    method: 'GET',
  })
    .then((response) => {
      // console.log('-------- getPickups response ---------->', response);

      return response.data;
    })
    .catch((error) => {
      // console.log('-------- getPickups catch err ---------->', error.response.data);
      return error.response.data;
    });
// Orders
const getOrders = (num, limit) =>
  apiV1AxiosInstance(`/orders/list/?page=${num}&page_size=${limit}`, {
    method: 'GET',
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      // console.log('-------- getOrders catch err ---------->', error.response);
      return error.response.data;
    });
const getFilteredOrders = (id, startDate, endDate, num, limit) =>
  apiV1AxiosInstance(`/orders/list/?order_id=${id}&date=${startDate}&end_date=${endDate}&page=${num}&page_size=${limit}`, {
    method: 'GET',
  })
    .then((response) => {
      // console.log('-------- getFilteredOrders response ---------->', response);
      return response.data;
    })
    .catch((error) => {
      // console.log('-------- getFilteredOrders catch err ---------->', error.response);
      return error.response.data;
    });
const getOrderById = (orderId) =>
  // orders/detail/str:id
  apiV1AxiosInstance(`/orders/detail/${orderId}`, {
    method: 'GET',
  })
    .then((response) => {
      // console.log('-------- getOrderDetail response  ---------->', response);
      return response.data;
    })
    .catch((error) => {
      // console.log('-------- getOrderDetail catch err ---------->', error.response);
      return error.response.data;
    });
const getShippingPDF = (id) =>
  apiV1AxiosInstance(`orders/pdf/?shipping_id=${id}`, {
    method: 'GET',
  })
    .then((response) => {
      // console.log('-------- getShippingPdf ---------->', response);
      return response.data;
    })
    .catch((error) => {
      // console.log('-------- getShippingPdf catch err ---------->', error.response);
      return error.response.data;
    });
const getOrderZip = (orderId) =>
  apiV1AxiosInstance(`/orders/zip/?order_id=${orderId}`, {
    method: 'GET',
  })
    .then((response) => {
      // console.log('-------- getOrderZip response ---------->', response);
      return response.data;
    })
    .catch((error) => {
      // console.log('-------- getOrderZip catch err ---------->', error.response);
      return error.response.data;
    });
// Addresses
const getAddresses = (num, limit) =>
  // /address?
  apiV1AxiosInstance(`/addresses/list/?page=${num}&page_size=${limit}`, {
    method: 'GET',
  }).then((response) => {
    // console.log('-------- getAddresses response ---------->', response);
    return response.data;
  });

// Addresses
const getAllAddressesToForm = (type) =>
  // /address?
  apiV1AxiosInstance(`/addresses/list/?pagination=false&address_type=${type}`, {
    method: 'GET',
  })
    .then((response) => {
      // console.log('-------- getAllAddressesToForm response ---------->', response);
      return response.data;
    })
    .catch((error) => {
      //  console.log('-------- getAllAddressesToForm catch err ---------->', error.response.data);
      return error.response.data;
    });
const getAddressesDetail = (id) =>
  apiV1AxiosInstance(`/addresses/detail/${id}`, {
    method: 'GET',
  }).then((response) => {
    // console.log('-------- getAddressesDetail response ---------->', response);
    return response.data;
  });

const getFilteredAddress = (name, num, limit) =>
  apiV1AxiosInstance(`/addresses/list/?name=${name}&page=${num}&page_size=${limit}`, {
    method: 'GET',
  }).then((response) => {
    // console.log('-------- getFilteredAddress response ---------->', response);
    return response.data;
  });

// Parcels
const getParcels = (num, limit) =>
  apiV1AxiosInstance(`/parcels/list/?page=${num}&page_size=${limit}`, {
    method: 'GET',
  }).then((response) => {
    // console.log('-------- getParcel response ---------->', response);
    return response.data;
  });

const getAllParcels = () =>
  apiV1AxiosInstance('/parcels/list/?pagination=false', {
    method: 'GET',
  })
    .then((response) => {
      // console.log('-------- getAllParcels response ---------->', response);
      return response.data;
    })
    .catch((error) => {
      //  console.log('-------- getAllParcels catch err ---------->', error.response);
      return error.response.data;
    });
const getFilteredParcels = (name, num, limit) =>
  apiV1AxiosInstance(`/parcels/list/?name=${name}&page=${num}&page_size=${limit}`, {
    method: 'GET',
  }).then((response) => {
    // console.log('-------- getFilteredParcels response ---------->', response);
    return response.data;
  });

// Support

const getSupportTickets = (num, limit) =>
  apiV1AxiosInstance(`/tickets/soporte?page=${num}&page_size=${limit}&included_modified_time=True`, {
    method: 'GET',
  }).then((response) => {
    // console.log('-------- getSupportTickets response ---------->', response.data);
    return response.data;
  });
const getFilteredSupportTickets = async (num, limit, state) => {
  const getStatusToRequest = () => {
    const status = {
      Abierto: 'OPEN',
      'En pausa': 'ON_PAUSE',
      Escalado: 'SCALING',
      'Solución favorable': 'FAVORABLE_SOLUTION',
      'Solución desfavorable': 'UNFAVORABLE_SOLUTION',
    };
    return status[state] || '';
  };
  const status = getStatusToRequest();
  return apiV1AxiosInstance(`/tickets/soporte?page=${num}&page_size=${limit}&ticket_status=${status}`, {
    method: 'GET',
  }).then((response) => {
    // console.log('-------- getFilteredSupportTickets response ---------->', response);
    return response.data;
  });
};
const getTicketDetail = (id) =>
  apiV1AxiosInstance(`/tickets/details/${id}`, {
    method: 'GET',
  })
    .then((response) => {
      // console.log('-------- getTicketDetail response ---------->', response.data);
      return response.data;
    })

    .catch((error) => {
      if (error.response) {
        // console.log('getTicketDetail catch:', error.response.data);
        return error.response.data;
      }
      throw error; // Si no hay respuesta, lanzar para el `catch` final
    });
const getResourcesForm = () =>
  apiV1AxiosInstance('/incidences/', {
    method: 'GET',
  })
    .then((response) => {
      // console.log('--------getResourcesForm response ---------->', response);
      return response.data;
    })
    .catch((error) => {
      // console.log('--------getResourcesForm  catch err ---------->', error.response);
      return error.response;
    });
// Get shipping companies
const getAllServices = () =>
  apiV1AxiosInstance('/carrier-data/shipping-company', {
    method: 'GET',
  })
    .then((response) => {
      // console.log('--------getAllServices response ---------->', response);
      return response.data;
    })
    .catch((error) => {
      // console.log('--------getAllServices  catch err ---------->', error.response);
      return error.response.data;
    });
// get available services list
const getAvailableServices = () =>
  apiV1AxiosInstance('/available-services', {
    method: 'GET',
  })
    .then((response) => {
      // console.log('--------getAvailableServices response ---------->', response);
      return response.data;
    })
    .catch((error) => {
      // console.log('--------getAvailableServices  catch err ---------->', error.response.data);
      return error.response.data;
    });
// /admin-invoices
// /admin-receipts
// /admin-reps
const getDocuments = (docType, page, limit) =>
  // /v1/invoices?page=1&page_size=10
  apiV1AxiosInstance(`/${docType}?page=${page}&page_size=${limit}`, {
    method: 'GET',
  }).then((response) => {
    // console.log('-------- getDocuments response ---------->', response.data);
    return response.data;
  });

const getShipment = (idDoc) =>
  // * Start Detalle de envio Page id = id del documento *
  apiV1AxiosInstance(`/shippings/${idDoc}`, {
    method: 'GET',
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      // console.log('-------- getShipment catch err ---------->', error.response);
      return error;
    });
const getChargeConcepts = () =>
  apiV1AxiosInstance('/admin-additional-charges', {
    method: 'GET',
  })
    .then((response) => {
      // console.log('-------- getChargeConcepts response ---------->', response.data);
      return response.data;
    })
    .catch((error) => {
      //  console.log('-------- getChargeConcepts catch err ---------->', error.response);
      return error.response;
    });
const getCommodities = () =>
  apiV1AxiosInstanceLogin('/get-commodities', {
    method: 'GET',
  })
    .then((response) => {
      // console.log('-------- getCommodities response ---------->', response.data);
      return response.data;
    })
    .catch((error) => {
      // console.log('-------- getCommodities catch err ---------->', error.response);
      return error.response;
    });
const getPolicyBeneficiaries = () =>
  apiV1AxiosInstance('/insurances-beneficiary/list/?pagination=False', {
    method: 'GET',
  })
    .then((response) => {
      // console.log('-------- getPolicyBeneficiaries response ---------->', response.data);
      return response.data;
    })
    .catch((error) => {
      // console.log('-------- getPolicyBeneficiaries catch err ---------->', error.response);
      return error.response;
    });
const getPlugins = (simulateErrorCode = null) => {
  if (simulateErrorCode === 400 || simulateErrorCode === 500) {
    const error = new Error(`Simulación de error ${simulateErrorCode}`);
    error.response = {
      status: simulateErrorCode,
      data: {
        error: { authentication: ['mensaje error, Token inválido o expirado.'] },
      },
    };
    return Promise.reject(error);
  }

  return apiV1AxiosInstance('/plugin-versions', {
    method: 'GET',
  }).then((response) => {
    // console.log('-------- getPluginOrders response ---------->', response);
    return response.data;
  });
};
const getPluginOrders = async (page, itemsPerPage, simulateErrorCode = null) => {
  // eslint-disable-next-line no-useless-catch
  try {
    if (simulateErrorCode === 400 || simulateErrorCode === 500) {
      const error = new Error(`Simulación de error ${simulateErrorCode}`);
      error.response = {
        status: simulateErrorCode,
        data: {
          error: { authentication: ['mensaje error pedidos, Token inválido o expirado.'] },
        },
      };
      return Promise.reject(error);
    }

    const response = await apiV1AxiosInstance(`/ecommerceorders/list?page=${page}&page_size=${itemsPerPage}`, {
      method: 'GET',
    });

    // console.log('-------- getPluginOrders response ---------->', response);
    return response.data;
  } catch (error) {
    // console.error('Error en getPluginOrders:', error);
    throw error; // Propaga el error para que sea manejado donde se llame
  }
};
const getPluginOrderDetail = async (id, simulateErrorCode = null) => {
  // eslint-disable-next-line no-useless-catch
  try {
    if (simulateErrorCode === 400 || simulateErrorCode === 500) {
      const error = new Error(`Simulación de error ${simulateErrorCode}`);
      error.response = {
        status: simulateErrorCode,
        data: {
          error: { authentication: ['mensaje error pedidos, Token inválido o expirado.'] },
        },
      };
      return Promise.reject(error);
    }
    const response = await apiV1AxiosInstance(`/ecommerceorders/details/${id}`, {
      method: 'GET',
    });
    // console.log('-------- getPluginOrderDetail response ---------->', response);
    return response.data;
  } catch (error) {
    // console.error('Error en getPluginOrderDetail:', error);
    throw error; // Propaga el error para que sea manejado donde se llame
  }
};
// get Plugins Shop
const getPluginShops = () =>
  apiV1AxiosInstance('/ecommercestores/list/', {
    method: 'GET',
  }).then((response) => {
    // console.log('-------- getPluginShops response ---------->', response);
    return response.data;
  });

const getFilteredPluginOrders = async (page, itemsPerPage, store, orderState, startDate, endDate, simulateErrorCode = null) => {
  if (simulateErrorCode === 400 || simulateErrorCode === 500) {
    const error = new Error(`Simulación de error ${simulateErrorCode}`);
    error.response = {
      status: simulateErrorCode,
      // data: {
      //   error: { authentication: ['mensaje error pedidos filtardos, Token inválido o expirado.'] },
      // },
    };
    return Promise.reject(error);
  }
  // console.log('estado:', orderState);
  const getStatusToRequest = (state) => {
    const status = {
      Incompleta: 'INCOMPLETED',
      Pendiente: 'PENDING',
      Completada: 'COMPLETED',
      Cancelada: 'CANCELLED',
    };
    return status[state] || '';
  };
  const status = getStatusToRequest(orderState);
  // console.log('estado editado antes de la peticion:', status);
  const response = await apiV1AxiosInstance(
    `/ecommerceorders/list?page=${page}&page_size=${itemsPerPage}&store_name=${store}&internal_status=${status}&date=${startDate}&end_date=${endDate}`,
    {
      method: 'GET',
    }
  );
  // console.log('-------- getFilteredPluginOrders response ---------->', response);
  return response.data;
};

// ****************** POSTS ********************************
const resetPasswordRequest = (email) =>
  apiV1AxiosInstanceLogin('/request-reset-pwd', { method: 'POST', data: { email } }).then((response) => {
    // console.log('-------- resetPasswordRequest response ---------->', response.data);
    return response.data;
  });

const resetPasswordConfirm = (uid, token, type, pwd) =>
  apiV1AxiosInstance('/reset-pwd-confirm', {
    method: 'POST',
    data: {
      uid,
      token,
      new_password: pwd,
      type,
    },
  }).then((response) => {
    // console.log('-------- resetPasswordConfirm response ---------->', response.data);
    return response.data;
  });

const onboardingProfile = (data) =>
  apiV1AxiosProvisionalInstance('/onboarding/profile-info/', {
    method: 'POST',
    data: {
      full_name: data.fullName,
      business_name: data.businessName,
      business_description: data.businessDescription,
      website_url: data.webSide,
    },
  }).then((response) => {
    // console.log('-------- onboardingProfile response ---------->', response.data);
    return response.data;
  });

const onboardingComplete = (data) =>
  apiV1AxiosProvisionalInstance('/onboarding/complete/', {
    method: 'POST',
    data: {
      wants_invoice: data.wantsInvoice,
      billing_email: data.email,
      legal_name: data.legalName,
      rfc: data.rfc,
      tax_system: data.system,
      street: data.street,
      street_number: data.streetNumber,
      zip_code: data.zip,
      neighborhood: data.neighborhood,
      city: data.city,
      state: data.state,
    },
  })
    .then((response) => {
      // console.log('-------- onboardingComplete response ---------->', response.data);
      return response.data;
    })
    .catch((error) => {
      // console.log('-------- onboardingComplete catch err ---------->', error.response.data);
      return Promise.reject(error);
    });

const updateInternalNotifications = (data) =>
  apiV1AxiosInstance('/profile/update/', {
    method: 'POST',
    data,
  }).then((response) => {
    // console.log('-------- updateInternalNotifications ---------->', response);
    return response;
  });
const updateExternalNotifications = async (data) => {
  // Create an object FormData
  const formData = new FormData();
  formData.append('destination_notifications_enabled', data.isActive);
  // array de lo contrario los convierte a string
  // data.selectedChannels.forEach((channel) => formData.append('destination_channels', channel));
  data.selectedState.forEach((status) => formData.append('destination_notification_statuses', status));
  // destination_channels
  if (data.selectedChannels.length > 0) {
    data.selectedChannels.forEach((channel) => {
      formData.append('destination_channels', channel);
    });
  } else {
    formData.append('destination_channels', JSON.stringify([]));
  }

  // destination_notification_statuses
  // if (data.selectedState.length > 0) {
  //   data.selectedState.forEach((status) => {
  //     formData.append('destination_notification_statuses', status);
  //   });
  // } else {
  //   formData.append('destination_notification_statuses', JSON.stringify([]));
  // }
  // Solo si hay archivo de lo contrario lo convierte a "null" string y debe ser null
  if (data.logoFile?.img) {
    formData.append('email_company_logo', data.logoFile.img);
  }
  formData.append('email_company_color', data.color.hex);
  formData.append('email_company_name', data.companyName);
  try {
    const response = await apiV1AxiosInstanceForm.post('/profile/update/', formData, {
      timeout: 15000,
    });
    return response.data;
  } catch (error) {
    if (error.response) {
      return error.response.data;
    }
    throw error;
  }
};

const createShipping = (shippingCode, shippingData) =>
  apiV1AxiosInstance('/shippings', {
    method: 'POST',
    data: {
      shipping_code: shippingCode,
      address_from: shippingData.addressFrom,
      address_to: shippingData.addressTo,
      parcel: shippingData.parcel,
      ...(shippingData.isInsurance && { insurance: shippingData.insurance }),
      ...(shippingData.products.order_ecommerce_id && { ecommerce_order: shippingData.products }),
    },
    timeout: 35000,
  }).then((response) => {
    // console.log('-------- createShipping PRUEBAS---------->', response);
    return response;
  });

const cancelShipping = (shippingID, requestReason) =>
  apiV1AxiosInstance('/shipping-cancelation', {
    method: 'POST',
    data: {
      shipping_id: shippingID,
      reason: requestReason,
    },
    timeout: 35000,
  }).then((response) => {
    // console.log('-------- cancelShipping response ---------->', response);
    // return response.data;
    return response.data;
  });

const editBillingData = (data) =>
  apiV1AxiosInstance('/billing/update/', {
    method: 'POST',
    data: {
      wants_invoice: data.wantsInvoice,
      billing_email: data.email,
      legal_name: data.legalName,
      rfc: data.rfc,
      tax_system: data.system,
      street: data.street,
      street_number: data.streetNumber,
      zip_code: data.zip,
      neighborhood: data.neighborhood,
      city: data.city,
      state: data.state,
    },
    timeout: 35000,
  }).then((response) => {
    // console.log('-------- editBillingData response ---------->', response);
    // return response.data;
    return response;
  });

const createAddress = (newAddress) =>
  // addresses/create/ nuevo
  // /address anterior
  apiV1AxiosInstance('/addresses/create/', {
    method: 'POST',
    data: {
      street_number: newAddress.streetNumber,
      company: newAddress.company, // opcional
      phone: newAddress.phone,
      street: newAddress.street,
      zip_code: newAddress.zip,
      email: newAddress.email, // opcional
      reference: newAddress.placeRef, // opcional
      neighborhood: newAddress.neighborhood,
      name: newAddress.name,
      address_type: newAddress.addressType,
    },
  }).then((response) => {
    // console.log('-------- createAddress response ---------->', response);
    return response;
  });

const createParcel = (parcel) =>
  apiV1AxiosInstance('/parcels/create/', {
    method: 'POST',
    data: {
      name: parcel.name,
      product_description: parcel.description,
      height: parcel.height,
      width: parcel.width,
      depth: parcel.depth,
      weight: parcel.weight,
      product_value: parcel.value ? parcel.value : 0,
      insurance: parcel.insurance,
    },
  }).then((response) => {
    // console.log('-------- createParcel response ---------->', response);
    return response;
  });

const createPickup = (pickup) =>
  apiV1AxiosInstance('/pickups', {
    method: 'POST',
    data: {
      shipping_code: pickup.shipping_code,
      address_from: {
        company: pickup.company,
        name: pickup.name,
        phone: pickup.phone,
        street: pickup.street,
        street_number: pickup.street_number,
        email: pickup.email,
        neighborhood: pickup.neighborhood,
        zip_code: pickup.zip_code,
        reference: pickup.reference,
        state: pickup.state,
        rfc: pickup.rfc,
        city: pickup.city,
      },
      shipping_id: pickup.shipping_id,
      total_packages: pickup.total_packages,
      total_weight: pickup.total_weight,
      pickup_time: 'MATUTINO',
      // pickup_time: pickup.pickup_time,
      pickup_date: pickup.pickup_date,
      side_streets: pickup.side_streets,
    },
  }).then((response) => {
    // console.log('-------- createPickup res ---------->', response);
    return response;
  });

const createOrder = (formData) =>
  apiV1AxiosInstance('/bulk_shippings', {
    method: 'POST',
    data: formData,
  })
    .then((response) => {
      // console.log('-------- createOrder responser ---------->', response.data);
      return response.data;
    })
    .catch((error) => {
      // console.log('-------- createOrder catch err ---------->', error.response.data);
      return error.response.data;
    });
/// tampoco se usa ???
const getOrderExcel = (type) =>
  apiV1AxiosInstance('/download-format', {
    method: 'POST',
    data: {
      code_concept: type,
    },
  })
    .then((response) => {
      //  console.log('-------- getOrderExcel res ---------->', response);
      return response.data;
    })
    .catch((error) => {
      // console.log('-------- getOrderExcel catch err ---------->', error.response.data);
      return error.response;
    });
const createSupportTicket = async (data) => {
  // console.log('-------- data  ---------->', data);
  const productDetails = `6.REPARAR?: ${toUpperIfString(data.isRepairable) ?? ''}| 7.COSTO: ${toUpperIfString(data.repairCost) ?? ''}| 8.CINTA?: ${
    toUpperIfString(data.packageTape) ?? ''
  }`;
  const productDescription = `2.DAÑO: ${toUpperIfString(data.packagingInternalDescription) ?? ''}| 4.PZAS: ${
    toUpperIfString(data.missingParts) ?? '0'
  }| 5.COINCIDE?: ${toUpperIfString(data.damagedDescription) ?? ''} `;
  // Create an object FormData
  const formData = new FormData();
  // Add form's fields to FormData
  formData.append('shipping_id', data.shippingId);
  formData.append('incident_type', data.incidentType);
  formData.append('shipping_company', data.serviceName);
  formData.append('insurance_policy', data.isInsurance ? 'Si' : 'No');
  formData.append('to_street', `${toUpperIfString(data.street ?? '')} ${data.streetNumber ?? ''}`);
  formData.append('to_neighborhood', toUpperIfString(data.neighborhood ?? ''));
  formData.append('to_zip_code', data.cp ?? '');
  formData.append('to_city', toUpperIfString(data.city ?? ''));
  formData.append('to_state', toUpperIfString(data.state ?? ''));
  formData.append('to_references', toUpperIfString(data.references ?? ''));
  formData.append('to_phone', data.phoneTo ?? '');
  formData.append('email', data.email ?? '');
  formData.append('to_sidestreets', toUpperIfString(data.betweenStreet ?? ''));
  formData.append('to_facade_color', toUpperIfString(data.facade ?? ''));
  formData.append('from_sidestreets', toUpperIfString(data.betweenStreetFrom ?? ''));
  formData.append('from_references', toUpperIfString(data.referencesFrom ?? ''));
  // info package
  formData.append('package_content', toUpperIfString(data.packageContent ?? ''));
  formData.append('package_value', 1);
  formData.append('packaging_description', toUpperIfString(data.packagingDescription ?? ''));
  formData.append('delivery_type', data.deliveryType ?? '');
  formData.append('missing_product_value', 1);
  formData.append('missing_product_details', productDetails);
  formData.append('missing_product_description', productDescription);
  formData.append('quantity_packages', 1);
  formData.append('total_weight_packages', 1);
  // evidencia
  formData.append('invoice_doc', data.invoiceFile);
  formData.append('evidence_1', data.photograph1 ?? '');
  formData.append('evidence_2', data.photograph2 ?? '');
  formData.append('evidence_3', data.photograph3 ?? '');
  formData.append('evidence_4', data.photograph4 ?? '');
  formData.append('evidence_5', data.photograph5 ?? '');
  formData.append('evidence_6', data.photograph6 ?? '');
  formData.append('evidence_7', data.protectionPhoto ?? '');
  formData.append('evidence_8', data.contentPhoto ?? '');
  formData.append('evidence_9', data.label ?? '');
  // formData.append('evidence_10', data.);
  // additional
  formData.append('additional_comments', toUpperIfString(data.comment));
  // console.log('FormData contents:', [...formData.entries()]);
  try {
    const response = await apiV1AxiosInstanceForm.post('/tickets/soporte', formData, {
      timeout: 35000,
    });
    // console.log('-------- createSupportTickets response  ---------->', response);
    return response.data;
  } catch (error) {
    // console.log('-------- 1 creategetSupportTickets  catch err ---------->', error);
    if (error.response) {
      return error.response.data;
    }
    throw error;
  }
};

// deactivateService
const deactivateService = (shippingCode) =>
  apiV1AxiosInstance('/block-service', {
    method: 'POST',
    data: {
      shipping_code: shippingCode,
    },
  })
    .then((response) => {
      // console.log('-------- deactivateService res ---------->', response);
      return response.data;
    })
    .catch((error) => {
      // console.log('-------- deactivateService catch err ---------->', error.response.data);
      return error.response;
    });

const createFinaceTicket = async (data) => {
  // Create an object FormData
  const formData = new FormData();
  // Add form's fields to FormData
  formData.append('shipping_id', data.labelId);
  formData.append('package_carrier', data.serviceName);
  formData.append('package_content', data.packageContent);
  formData.append('incident_type', data.incidentType);
  // formData.append('date_request', data.);
  // formData.append('date_create', data.);
  // formData.append('measures', data.);
  // formData.append('weight', data.);
  // formData.append('cost', data.);
  // formData.append('account_info', data.);
  // formData.append('reason_request', data.);
  // formData.append('long_pic', data.);
  // formData.append('width_pic', data.);
  // formData.append('height_pic', data.);
  // formData.append('guide_pic', data.);
  // formData.append('weight_pic', data.);
  // formData.append('', data.);

  // Use Axios Instance to send the data
  try {
    const response = await apiV1AxiosInstanceForm.post('/tickets/finanzas', formData, {
      timeout: 35000,
    });
    return response;
  } catch (error) {
    return error.response;
  }
};
const getFinancePdf = (doc, folio) =>
  apiV1AxiosInstance(`/get-${doc}-pdf`, {
    method: 'POST',
    data: {
      folio_number: folio,
    },
  })
    .then((response) => {
      // console.log('-------- getFinancePdf res ---------->', response);
      return response.data;
    })
    .catch((error) => {
      // console.log('-------- getFinancePdf catch err ---------->', error.response.data);
      return error.response.data;
    });
const getFinanceXml = (doc, folio) =>
  apiV1AxiosInstance(`/get-${doc}-xml`, {
    method: 'POST',
    data: {
      folio_number: folio,
    },
  })
    .then((response) => {
      // console.log('-------- getFinanceXml res ---------->', response);
      return response.data;
    })
    .catch((error) => {
      // console.log('-------- getFinanceXml catch err ---------->', error.response.data);
      return error.response;
    });
const createPolicyBeneficiary = (data) =>
  apiV1AxiosInstance('/insurances-beneficiary/create/', {
    method: 'POST',
    data: {
      name: data.name,
      rfc: data.rfc,
    },
  })
    .then((response) => {
      // console.log('-------- createPolicyBeneficiary res ---------->', response.data);
      return response.data;
    })
    .catch((error) => {
      // console.log('-------- createPolicyBeneficiary catch err ---------->', error.response.data);
      return error.response.data;
    });
// ****************** DELETE ********************************

const deleteAddress = (id) =>
  apiV1AxiosInstance(`/addresses/delete/${id}`, {
    method: 'PUT',
  }).then((response) => {
    // console.log('-------- deleteAddress response  ---------->', response.data);
    return response;
  });

const deleteParcel = (id) =>
  apiV1AxiosInstance(`/parcels/delete/${id}`, {
    method: 'PUT',
  }).then((response) => {
    return response;
  });

// activateService
const activateService = (shippingCode) =>
  apiV1AxiosInstance('/unblock-service', {
    method: 'DELETE',
    data: {
      shipping_code: shippingCode,
    },
  })
    .then((response) => {
      // console.log('-------- activateServices response ---------->', response.data);

      return response.data;
    })
    .catch((error) => {
      // console.log('-------- activateServices catch err ---------->', error.response.data);
      return error.response.data;
    });
const deletePolicyBeneficiary = (id) =>
  apiV1AxiosInstance(`/insurances-beneficiary/delete/${id}`, {
    method: 'DELETE',
  })
    .then((response) => {
      // console.log('-------- deletePolicyBeneficiary response ---------->', response.data);
      return response.data;
    })
    .catch((error) => {
      // console.log('-------- deletePolicyBeneficiary catch err ---------->', error.response.data);
      return error.response.data;
    });
// ****************** PUT ********************************

const editAddress = (id, address) =>
  apiV1AxiosInstance(`/addresses/update/${id}`, {
    method: 'PUT',
    data: {
      street_number: address.streetNumber,
      company: address.company,
      phone: address.phone,
      street: address.street,
      zip_code: address.zip,
      email: address.email,
      reference: address.reference,
      neighborhood: address.neighborhood,
      name: address.name,
      address_type: address.addressType,
    },
  }).then((response) => {
    // console.log('-------- editAddress response  ---------->', response.data);
    return response;
  });

const editParcel = (id, parcel) =>
  apiV1AxiosInstance(`/parcels/update/${id}`, {
    method: 'PUT',
    data: {
      name: parcel.name,
      product_description: parcel.product_description,
      height: parcel.height,
      width: parcel.width,
      depth: parcel.depth,
      weight: parcel.weight,
      product_value: parcel.product_value || 0,
      insurance: parcel.insurance,
    },
  }).then((response) => {
    // console.log('-------- editParcels response ---------->', response);
    return response;
  });

const editPolicyBeneficiary = (data) =>
  apiV1AxiosInstance(`/insurances-beneficiary/update/${data.id}`, {
    method: 'PUT',
    data: {
      name: data.name,
      rfc: data.rfc,
    },
  })
    .then((response) => {
      // console.log('--------  editPolicyBeneficiary response ---------->', response);
      return response.data;
    })
    .catch((error) => {
      // console.log('--------  editPolicyBeneficiary catch err ---------->', error.response.data);
      return error.response.data;
    });
const editPluginStore = (data) => {
  const formData = new FormData();
  formData.append('name', data.name);
  formData.append('store_ecommerce_id', data.id);
  if (data.img) {
    formData.append('store_custom_img', data.img);
  }

  return apiV1AxiosInstance('/ecommercestores/update/', {
    method: 'PUT',
    data: formData,
  }).then((response) => {
    // console.log('-------- editEcommerceStore responser ---------->', response.data);
    return response.data;
  });
};

const test = (id, simulateErrorCode = null) => {
  if (simulateErrorCode === 400 || simulateErrorCode === 500) {
    const error = new Error(`Simulación de error ${simulateErrorCode}`);
    error.response = {
      status: simulateErrorCode,
      data: {
        error: { example: ['mensaje error, error message .'] },
      },
    };
    return Promise.reject(error);
  }

  return apiV1AxiosInstance(`/addresses/detail/${id}`, {
    method: 'GET',
  }).then((response) => {
    // console.log('-------- getPluginOrders response ---------->', response);
    return response.data;
  });
};
export {
  login,
  register,
  getVerificationStatus,
  getVerificationUpdate,
  getProfile,
  getBillingInfo,
  validateEmail,
  sendVerificationCode,
  getCounters,
  getZipCode,
  getRates,
  getShippingHistory,
  getShippingDetails,
  getFilteredHistory,
  getStatementsHistory,
  getStatementsFiltered,
  getOverweightHistory,
  getPickups,
  getOrders,
  getFilteredOrders,
  getOrderById,
  getShippingPDF,
  getOrderZip,
  getAddresses,
  getAllAddressesToForm,
  getAddressesDetail,
  getFilteredAddress,
  getParcels,
  getAllParcels,
  getFilteredParcels,
  getSupportTickets,
  getFilteredSupportTickets,
  getTicketDetail,
  getResourcesForm,
  getAllServices,
  getAvailableServices,
  getDocuments,
  getShipment,
  getChargeConcepts,
  getCommodities,
  getPolicyBeneficiaries,
  getPlugins,
  getPluginOrders,
  getPluginOrderDetail,
  getPluginShops,
  getFilteredPluginOrders,
  // POST
  resetPasswordRequest,
  resetPasswordConfirm,
  onboardingProfile,
  onboardingComplete,
  updateInternalNotifications,
  updateExternalNotifications,
  createShipping,
  cancelShipping,
  editBillingData,
  createAddress,
  createParcel,
  createPickup,
  createOrder,
  getOrderExcel,
  createSupportTicket,
  createFinaceTicket,
  deactivateService,
  getFinancePdf,
  getFinanceXml,
  createPolicyBeneficiary,
  // DELETE
  deleteAddress,
  deleteParcel,
  activateService,
  deletePolicyBeneficiary,
  // EDIT
  editAddress,
  editParcel,
  editPolicyBeneficiary,
  editPluginStore,
};
